/** Import Node Modules */
import React, { Component } from "react";

/** Import Redux Library */
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { change, destroy, formValueSelector } from "redux-form";
import ReactPaginate from "react-paginate";

/** Import Local Components */
import { Dialog } from "../../../core";
import {
  Resources as campaignResources,
  postArchivedItems,
  removeSingleArchivedCampaign,
  unArchiveItems
} from "../../campaign/redux/campaignRedux";
import { Resources } from "../redux/archiveRedux";
import CampaignArchiveTable from "../modules/campaignArchiveTable";

class ArchiveCampaign extends Component {
  constructor(props) {
    super(props);
    this.perPageCount = 20;
    Resources.getArchivedCampaign.url = `/campaigns/archive?page=${1}&per_page=${
      this.perPageCount
    }`;
    this.props.Get(Resources.getArchivedCampaign).then(() => {
      this.setState({
        isLoading: false
      });
    });
    this.archiveTableRefs = React.createRef();
    this.initialSortOrder = {
      name: { active: false, sortBy: "desc" },
      screen_size: { active: false, sortBy: "desc" },
      orientation: { active: false, sortBy: "desc" },
      status: { active: false, sortBy: "desc" },
      created_at: { active: false, sortBy: "desc" },
      updated_at: { active: false, sortBy: "desc" }
    };
    this.state = {
      forcePage: undefined,
      isLoading: true,
      sortOrder: this.initialSortOrder,
      sortValue: { isSortable: false },
      deleteModal: {
        id: undefined,
        modal: false,
        body: "Are you Sure you want to delete this content.",
        title: "Confirm Delete"
      }
    };
  }

  handleSort = name => {
    this.setState({ isLoading: true, forcePage: 0 });
    this.props.change("SelectedCampaignsOnArchive", "campaignsSelected", []);
    this.archiveTableRefs.current.selectionContext.selected = [];
    this.archiveTableRefs.current.setState({});
    this.setState(
      prevState => ({
        sortOrder: {
          ...this.initialSortOrder,
          [name]: {
            active: true,
            sortBy: prevState.sortOrder[name].sortBy === "desc" ? "asc" : "desc"
          }
        },
        sortValue: {
          name,
          active: true,
          sortBy: prevState.sortOrder[name].sortBy === "desc" ? "asc" : "desc",
          isSortable: true
        }
      }),
      () => {
        const { getArchivedCampaign } = Resources;
        getArchivedCampaign.url = `/campaigns/archive/?sort=${name}&sort_by=${
          this.state.sortOrder[name].sortBy
        }&page=${1}&per_page=${this.perPageCount}`;
        this.props
          .Get(Resources.getArchivedCampaign)
          .then(() => this.setState({ isLoading: false }));
      }
    );
  };

  handleUnArchiveItem = id => {
    const { unArchiveCampaign } = campaignResources;
    unArchiveCampaign.body = unArchiveItems({ filteredCampaignId: [id] });
    this.props
      .Put(unArchiveCampaign)
      .then(() => {
        this.props.Get(Resources.getArchivedCampaign).then(result => {
          if (result.status === 200) {
            return (
              this.props.campaignList.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
      })
      .then(() =>
        this.props.change("SelectedCampaignsOnArchive", "campaignsSelected", [])
      );
  };

  handleUnArchiveItems = () => {
    const filteredCampaignId = this.props.selectedCampaign.map(item => item.id);
    const { unArchiveCampaign } = campaignResources;
    unArchiveCampaign.body = unArchiveItems({ filteredCampaignId });
    this.props
      .Put(unArchiveCampaign)
      .then(() => {
        this.props.Get(Resources.getArchivedCampaign).then(result => {
          if (result.status === 200) {
            return (
              this.props.campaignList.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
      })
      .then(() =>
        this.props.change("SelectedCampaignsOnArchive", "campaignsSelected", [])
      )
      .then(() => {
        this.archiveTableRefs.current.selectionContext.selected = [];
        this.archiveTableRefs.current.setState({});
      });
  };

  handleDeleteConfirmation = (id, name) => {
    const { deleteModal } = this.state;
    deleteModal.modal = true;
    deleteModal.id = id;
    deleteModal.body = (
      <span>
        <small>Are you sure you want to delete </small>
        <strong>{name}</strong>?
      </span>
    );

    this.setState({ deleteModal });
  };

  handleDelete = () => {
    const { deleteModal } = this.state;
    const filteredCampaignId = this.props.selectedCampaign.map(item => item.id);
    const { removeBulkCampaign } = campaignResources;
    if (deleteModal.id) {
      removeBulkCampaign.body = removeSingleArchivedCampaign(deleteModal.id);
    } else {
      removeBulkCampaign.body = postArchivedItems({ filteredCampaignId });
    }
    this.props
      .Put(removeBulkCampaign)
      .then(() => {
        this.props.Get(Resources.getArchivedCampaign).then(result => {
          if (result.status === 200) {
            return (
              this.props.campaignList.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
        deleteModal.modal = false;
        deleteModal.id = undefined;
        this.setState({
          deleteModal
        });
      })
      .then(() =>
        this.props.change("SelectedCampaignsOnArchive", "campaignsSelected", [])
      )
      .then(() => {
        this.archiveTableRefs.current.selectionContext.selected = [];
        this.archiveTableRefs.current.setState({});
      });
  };

  toggleModel = flag => {
    const { deleteModal } = this.state;
    deleteModal.modal = flag;
    this.setState({ deleteModal });
    this.forceUpdate();
  };

  /**
   * @param {id}  campaign id
   */

  /**
   * @param {id}  campaign id
   */
  handlePageClick = (data, moveToPrevious = false) => {
    window.scrollTo(0, 0);
    this.setState({ isLoading: true });
    const { getArchivedCampaign } = Resources;
    if (moveToPrevious) {
      getArchivedCampaign.url = `/campaigns/archive?page=${data.page -
        1}&per_page=${this.perPageCount}`;
      this.props.Get(getArchivedCampaign).then(() => {
        this.setState({ forcePage: data.page - 2, isLoading: false });
      });
    } else {
      this.setState({ forcePage: undefined });
      this.setState({ isLoading: true });
      const { selected } = data;
      if (this.state.sortValue.isSortable) {
        getArchivedCampaign.url = `/campaigns/archive?sort=${
          this.state.sortValue.name
        }&sort_by=${this.state.sortValue.sortBy}&page=${selected +
          1}&per_page=${this.perPageCount}`;
      } else {
        getArchivedCampaign.url = `/campaigns/archive?page=${selected +
          1}&per_page=${this.perPageCount}`;
      }
      this.props
        .Get(getArchivedCampaign)
        .then(() => this.setState({ forcePage: selected, isLoading: false }));
    }
  };

  render() {
    const { deleteModal } = this.state;

    return (
      <div>
        <Dialog
          externalControl
          showHandler={false}
          modal={deleteModal.modal}
          body={deleteModal.body}
          title={deleteModal.title}
          toggleModel={this.toggleModel}
          primaryMethod={this.handleDelete}
        />
        <CampaignArchiveTable
          {...this.props}
          forwardRef={this.archiveTableRefs}
          handleDelete={this.handleDeleteConfirmation}
          isLoading={this.state.isLoading}
          campaignList={this.props.campaignList}
          handleUnArchiveItem={this.handleUnArchiveItem}
          handleSort={this.handleSort}
          sortOrder={this.state.sortOrder}
          // following props used for bulk archive and delete
          handleUnArchiveItems={this.handleUnArchiveItems}
          handleDeleteConfirmation={this.handleDeleteConfirmation}
          selectedContentsLen={this.props.selectedCampaign.length}
        />
        {!this.state.isLoading &&
          this.props.campaignList &&
          this.props.campaignList.length > 0 && (
            <div className="contentSectionPagination clearfix">
              <ReactPaginate
                pageCount={this.props.meta ? this.props.meta.totalPages : 0}
                pageRangeDisplayed={3}
                onPageChange={this.handlePageClick}
                marginPagesDisplayed={2}
                activeClassName="active"
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                previousLabel="<"
                forcePage={this.state.forcePage}
                nextLabel=">"
                breakLabel="..."
                breakClassName="break-me"
                disabledClassName="paginationDisable"
              />
            </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    list,
    status,
    loading,
    hasError,
    meta,
    filterStatus
  } = state.archiveCampaign;
  const selector = formValueSelector("SelectedCampaignsOnArchive");

  return {
    campaignList: list !== undefined ? list : [],
    selectedCampaign: selector(state, "campaignsSelected") || [],
    loading,
    hasError,
    meta,
    status,
    filterStatus
  };
}

export default connect(
  mapStateToProps,
  { change }
)(ArchiveCampaign);
